import { cardFrameCSS, StCard } from './Card.styled'

import type { CardProps } from './Card.types'

const Card = ({ active, disabled, children, className, style, onClick }: CardProps) => {
  return (
    <StCard active={active} disabled={disabled} className={className} onClick={onClick} style={style}>
      {children}
    </StCard>
  )
}

export type { CardProps } from './Card.types'
export { Card, cardFrameCSS }
